import React from 'react';
import { FileCheck2Icon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { TransformCta } from '../TransformCta';
import { pathwaySteps } from '../../data/pathway';
export function Pathway() {
  return <section className="bg-panel py-16 sm:py-24" aria-labelledby="pathway-title" data-id="element-279" data-mp="4cvkq1z8nq8f">
      <div className="mx-auto max-w-4xl px-5" data-id="element-280" data-mp="9a3w9jpvsw0p">
        <SectionHeading kicker="Introducing the HVAC Electrical Fault Pathway™" title={<span id="pathway-title" data-id="element-282" data-mp="3cs5kv4jkildk">Your 5-step system for organizing HVAC electrical troubleshooting</span>} lead="A five-stage workflow that connects symptom assessment, circuit identification, verification planning, diagnostic interpretation, and professional documentation." data-id="element-281" data-mp="38qk1d0cj38ue" />

        <ol className="relative mt-14" data-id="element-283" data-mp="3mnyxsp178gvv">
          {pathwaySteps.map((step, i) => <li key={step.verb} className="relative flex gap-4 pb-10 last:pb-0 sm:gap-6" data-id="element-284" data-mp="x33vv9vcxadi" data-mpi={i}>
              {i < pathwaySteps.length - 1 && <span className="absolute left-[27px] top-14 h-[calc(100%-56px)] w-[2px] bg-volt/40 sm:left-[31px]" aria-hidden="true" data-id="element-285" data-mp="1c610dz162u4f" />}
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-volt font-display text-3xl font-extrabold text-ink sm:h-16 sm:w-16 sm:text-4xl" data-id="element-286" data-mp="181tcg42j9i79">
                {i + 1}
              </span>
              <div className="min-w-0 flex-1 pt-1" data-id="element-287" data-mp="t6n5nevm5fcv">
                <p className="font-display text-xl font-bold uppercase tracking-wide text-volt" data-id="element-288" data-mp="t87zt3e0mwa7">
                  Step {i + 1} — {step.verb}
                </p>
                <h3 className="mt-1 font-display text-[28px] font-bold uppercase leading-tight text-white sm:text-3xl" data-id="element-289" data-mp="kdtlp4581rso">
                  {step.title}
                </h3>
                <p className="mt-3 text-[16px] leading-relaxed text-mist" data-id="element-290" data-mp="fdfdnm3mehun">{step.body}</p>
                <p className="mt-4 flex items-start gap-2 rounded-xl bg-ink px-4 py-3 text-[15px] text-white ring-1 ring-line" data-id="element-291" data-mp="ai9qkjyhex4z">
                  <FileCheck2Icon className="mt-0.5 h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-292" data-mp="3rz494binjipl" />
                  <span data-id="element-293" data-mp="s9tn8n7aboz">
                    <strong className="text-amber" data-id="element-294" data-mp="tkxf8gnbjg3">Your output:</strong> {step.output}
                  </span>
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mt-14 text-center font-display text-4xl font-extrabold uppercase text-white" data-id="element-295" data-mp="3myztsothcu0y">
          Five stages. <span className="text-volt" data-id="element-296" data-mp="el9abdypyby4">One organized workflow.</span>
        </p>

        <TransformCta label="Get instant access to the complete system" data-id="element-297" data-mp="jjas7vkes580" />
      </div>
    </section>;
}